import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_hoodie_items",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-25px rounded-start" }, "Size"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-25px" }, "Quantity")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode("   "),
  /*#__PURE__*/_createVNode("b", null, "Total")
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("   ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", null, "Order #" + _toDisplayString(_ctx.ordernum) + " (" + _toDisplayString(_ctx.dzyn) + ")", 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("table", _hoisted_10, [
                _hoisted_11,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", null, "   " + _toDisplayString(item.hoodie_size), 1),
                      _createVNode("td", null, "   " + _toDisplayString(item.hoodie_qty), 1)
                    ]))
                  }), 128)),
                  _createVNode("tr", null, [
                    _hoisted_12,
                    _createVNode("td", null, [
                      _hoisted_13,
                      _createVNode("b", null, _toDisplayString(_ctx.totalQty), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}